import { createListenerMiddleware } from '@reduxjs/toolkit';
import certificationApi from '../apis/certification.api';
import { CERTIFICATION_DELETE, CERTIFICATION_UPDATE } from './action.types';

import type { AppDispatch } from '../storeConfig/store';

export const certificationListener = createListenerMiddleware();

const deleteCertificationInternal = async (
	profileId: number,
	profileCertificationId: number,
	dispatch: AppDispatch
) => {
	await dispatch(
		certificationApi.endpoints.deleteCertification.initiate({ profileId, profileCertificationId })
	).unwrap();
	await dispatch({
		type: 'SET_TOAST',
		data: { title: 'Certification deleted', show: true, showSuccessTick: true }
	});
};

export const deleteCertificationForProfile =
	(profileId: number, profileCertificationId: number) => async (dispatch: AppDispatch) => {
		await deleteCertificationInternal(profileId, profileCertificationId, dispatch);
	};

const updateCertificationInternal = async (
	profileId: number,
	profileCertId: number,
	profileSustainabilityFormId: number,
	file: File,
	certId: number,
	dispatch: AppDispatch
) => {
	await dispatch(
		certificationApi.endpoints.updateCertification.initiate({
			profileId,
			profileCertId: profileCertId,
			request: { file, certId, profileSustainabilityFormId }
		})
	).unwrap();

	await dispatch({
		type: 'SET_TOAST',
		data: { title: 'Certification updated', show: true, showSuccessTick: true }
	});
};

certificationListener.startListening({
	matcher: certificationApi.endpoints.submitCertification.matchFulfilled,
	effect: async (_action, { dispatch }) => {
		dispatch({
			type: 'SET_TOAST',
			data: { title: 'Certification submitted', show: true, showSuccessTick: true }
		});
	}
});

certificationListener.startListening({
	predicate: (action) => action.type === CERTIFICATION_DELETE,
	effect: async (action, { dispatch }) => {
		const { profileId, profileCertificationId } = action.payload ?? {};
		if (profileId === null || profileCertificationId === null) return;
		await deleteCertificationInternal(
			profileId,
			profileCertificationId,
			dispatch as AppDispatch
		);
	}
});

certificationListener.startListening({
	predicate: (action) => action.type === CERTIFICATION_UPDATE,
	effect: async (action, { dispatch }) => {
		const { profileId, profileCertId, profileSustainabilityFormId, file, certId } =
			action.payload ?? {};
		if (profileId === null || profileCertId === null || !file) return;
		await updateCertificationInternal(
			profileId,
			profileCertId,
			profileSustainabilityFormId,
			file,
			certId,
			dispatch as AppDispatch
		);
	}
});
